import React from "react";

const ProgramSummaryCard = ({ index, props }) => {
  return (
    <div className="flex w-8/12 h-[10rem]">
      <div
        className={`bg-white dark:bg-gray-500 dark:text-white text-black p-8 border-l-[.4rem] rounded-l-md flex flex-col basis-6/12 ${[
          props.border,
        ]}`}
      >
        <h3>{`STEP ${index + 1}: ${props.title}`}</h3>
        <span className="text-4xl">{props.count}</span>
      </div>
      <div className="basis-6/12 bg-white flex justify-center items-center text-gray-300 dark:bg-gray-500 dark:text-white">
        {" "}
        {props.icon}
      </div>
    </div>
  );
};

export default ProgramSummaryCard;
